const NAME = "FAMILY_SETTINGS_PAGE";

export default NAME;
